import React, { Component } from 'react';
import classNames from 'classnames';

import PostLink from "../../../../Blog/elements/PostLink";

import styles from './style.sass';


export default ({event}) => (event.data && event.data.links !== undefined || event.posts !== undefined) &&
    <section className={classNames(styles.root, 'exposed-soft skewed')}>
        <div className="larger grid">

            {event.data.links !== undefined && (
                <article>
                    <h3 className="g-type-title-section g-type-title-left line-flat">Przydatne linki</h3>
                    <LinksList links={event.data.links} />
                </article>
            )}

            {event.posts !== undefined && (
                <article>
                    <h3 className="g-type-title-section g-type-title-left line-flat">Posty</h3>
                    <PostsLinksList links={event.posts} />
                </article>
            )}

        </div>
    </section>

const LinksList = ({links}) => (
    <ul>
        {links.map((link, i) =>
            <li key={i}>
                <a href={link.href}>{link.label}</a>
            </li>
        )}
    </ul>
);

const PostsLinksList = ({links}) => (
    <ul>
        {links.map((link, i) =>
            <li key={i}>
                {!link.resource ? (
                    <a href={link.href}>{link.label}</a>
                ) : (
                    <PostLink post={link.resource}>{link.resource.title}</PostLink>
                )}
            </li>
        )}
    </ul>
);


// WEBPACK FOOTER //
// ./src/modules/Events/pages/Show/Resources/index.js